import { ReactElement } from 'react';
import LoadingIndicator from './LoadingIndicator';

interface Props {
  description: string;
  containerStyle?: string;
}

export default function LoadingWithText(props: Props): ReactElement {
  const { description, containerStyle } = props;

  return (
    <div className={containerStyle ?? container}>
      <div className={wrapper}>
        <div className={loadingWrapper}>
          <div className="-mb-[10px]">
            <LoadingIndicator lg={60} md={50} sm={40} />
          </div>
        </div>
        <p className={descriptionStyle}>{description}</p>
      </div>
    </div>
  );
}

const container = 'w-full h-full z-50 fixed top-0 bg-black/60 dark:bg-black/70 dark:backdrop-blur-md';

const wrapper = 'w-full h-full z-50 fixed top-0 flex flex-col justify-center items-center';

const loadingWrapper =
  'bg-brand-card dark:border dark:border-brand-border lg:h-24 lg:w-24 md:h-20 md:w-20 h-16 w-16 rounded-lg flex justify-center items-center';

const descriptionStyle = 'text-white text-center mt-lg px-lg';
